import { Component } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router, ActivatedRoute } from '@angular/router';
import { finalize } from 'rxjs';
import { ApiService } from 'src/app/services/api/api.service';
import { ErrorModalComponent } from 'src/app/shared/modals/error-modal/error-modal.component';
import { SuccessModalComponent } from 'src/app/shared/modals/success-modal/success-modal.component';
import { Location } from "@angular/common";
import { AuthService } from 'src/app/services/auth/auth.service';
import { GenerateCouponModalComponent } from '../generate-coupon-modal/generate-coupon-modal.component';

@Component({
  selector: 'app-coupon-landing',
  standalone: false,
  templateUrl: './coupon-landing.component.html',
  styleUrl: './coupon-landing.component.scss'
})
export class CouponLandingComponent {

  action_idx: any = null;

  data: any;

  form!: FormGroup;

  isSearching: boolean = false;
  showSearchForm: boolean = false;

  searchedDataNotFound = false;
  isEmpty!: boolean;
  searched = false;

  selectedStatus!: boolean;

  isDarkMode!: boolean;

  page: number = 0;
  num: number = 1;
  currentPage: number = 1;
  count: number = 0;
  pageSize: number = 20;
  selectedLimit: number = 10;


  errorFetchingData: boolean = false;


  toggleShowSearch() {
    this.showSearchForm = !this.showSearchForm;
  }



  clearSearchFilters() {
    this.form.reset();
    this.showSearchForm = false;
    this.data = null;
    this.count = 0;
  }

  constructor(
    public fb: FormBuilder,
    private apiService: ApiService,
    public dialog: MatDialog,
    private router: Router,
    private route: ActivatedRoute,
    private location: Location,
    private authService: AuthService
  ) { }

  ngOnInit(): void {
    this.form = this.fb.group({
      email: [''],
      paymentReference: [''],
      status: [''],
      from: [''],
      to: [''],
    });

    this.search();
  }


  hasAccess(permissions: string[]) {
    return this.authService.hasAnyPermission(permissions)
  }



  openErrorModal(message: string) {
    let dialogRef = this.dialog.open(ErrorModalComponent, {
      width: '350px',
      backdropClass: 'modal-form-backdrop',
      hasBackdrop: true,
      panelClass: ['modal-form', 'modal-no-overflow-changed'],
      data: { errorMessage: message },
    });

    return dialogRef
  }

  callDb(event: any) {
    this.currentPage = event;

    this.page = event - 1;

    this.search();
  }

  updateLimit() {
    this.currentPage = 1;

    this.page = 0;

    this.search();

  }

  openGenerateCouponModal(){

     let dialogRef = this.dialog.open(GenerateCouponModalComponent, {
      backdropClass: 'modal-form-backdrop',
      hasBackdrop: true,
      disableClose: true,
      panelClass: ['modal-form', 'custom-dialog-md'],
    });

    dialogRef.afterClosed().subscribe((data) => {

    })

  }



  search() {
    this.data = null
    this.searchedDataNotFound = false;
    this.errorFetchingData = false
    this.isSearching = true;
    this.form.markAsPristine()

    this.pageSize = this.selectedLimit;

    this.num = this.page * this.selectedLimit;

    var formData: any = new FormData();
    const formValues = this.form.value;

    formData.append('offset', this.num);
    formData.append('limit', this.selectedLimit);

    formValues.email && formData.append('email', formValues.email.trim());
    formValues.paymentReference && formData.append('paymentReference', formValues.paymentReference.trim());
    formValues.status && formData.append('status', formValues.status);
    formValues.from && formData.append('from', formValues.from);
    formValues.to && formData.append('to', formValues.to);

    this.apiService
      .post('/reconciliation/page', formData)
      .pipe(
        finalize(() => {
          this.isSearching = false;
        })
      )
      .subscribe(
        (response) => {

          this.count = response?.pagedResponse?.totalElements;

          if (this.count == 0) {
            this.searchedDataNotFound = true;
          }

          this.data = response?.data;

        },
        (error) => {
          this.openErrorModal(error?.message);
          this.errorFetchingData = true
        }
      );
  }



}
